import { AllSameKeysEnforcer, AllSameKeyValuesEnforcer, sortByProp } from '../helpers/helpers'
import { JoiFile } from './files.model'
import { Venue } from './events.data'
import { BrandingData, HomePageData } from './publish.data'
import { BasePublishInfo } from './share.data'
import { SortOption } from './user.data'

export interface InstanceInfo {
  publishIds: string[]
}

export interface EventListInfo extends BasePublishInfo {
  eventInstanceMap: { [eventId: string]: InstanceInfo[] } // I made it map to a list of objects in case we want to add things like custom title or other attributes to an instance
  publishedIds?: string[] // This refers to the ids of publishes that were included in a PUBLISHED event list.  The data in eventInstanceMap has the current selections, not the published ones, and getting the published ids from the actual published event lists is a no go, as well.  So this needs to be updated when publishing / unpublishing event lists (and of course when deleting a single publish)
  sortOption: SortOption
  createdAt?: number // improper typing of publish info led to this confusing situation where event lists use number and publish infos use dates
  // eventThumbs?: { [eventId: string]: string }
  instanceThumbs?: { [eventId: string]: string[] }
}

export interface DateBlock { day: number, month: string }


export interface EventListPublishInstance {
  eventId: string
  eventName: string
  dates: { start: string, end: string } // null if no dates
  dateBlocks: { start: DateBlock, end: DateBlock } // null if no dates
  publishes: EventListPublish[]
  thumbnail: string
  index: number
}

export interface SortedEventListPublishInstances {
  upcoming: EventListPublishInstance[]
  past: EventListPublishInstance[]
}

export interface EventListsData {
  accountId: string
  accountName: string
  accountLogoUrl: string
  id: string
  publishCalendarData: { [publishId: string]: ProgramPublishCalendarData }
  instances: EventListPublishInstance[]
  customPublishCSSUrl?: string
}

export interface PublishedEventListsData extends EventListsData {
  info: EventListInfo
  brandingData: BrandingData
}

export interface EventListTabs { future: string, past: string }
export const getDefaultEventListTabNames = (): AllSameKeysEnforcer<EventListTabs> => ({ future: 'Upcoming Events', past: 'Past Events '})
export const eventListTabs: AllSameKeyValuesEnforcer<EventListTabs> = { future: 'future', past: 'past' }


export interface ProgramPublishCalendarData {
  publishId: string
  publishTitle: string
  eventId: string
  eventTitle: string
  days:{
    start: string // UTC time str
    end: string // UTC time str
  }[]
  venue: Venue
}

export interface UpdateEventListWithPublishesQuery {
  accountId: string
  eventListId: string
  publishCodes: string[]
  updatedPublishes: { [id:string]: EventListPublish }
  updatedCalendarData: { [id: string]: ProgramPublishCalendarData }
}


export interface UnpublishOrDeleteEventListsQuery {
  accountId: string
  publishCode: string
  date: number
  command: 'unpublish' | 'delete'
}

export interface UnpublishOrDeletePublishesFromEventListsQuery {
  eventListId: string
  publishCodes: string[]
  permanent: boolean
  accountId: string
}


export interface EventListPublish {
  id: string
  name: string
  publishLink: string
  dates: { start: string, end: string } // null if no dates
  dateString: string
  venue: Venue
  CTALinks: JoiFile[]
}

export const getUpcomingAndPastEventListInstances = (instances: EventListPublishInstance[]): SortedEventListPublishInstances => {
    const now = new Date().getTime()
  const datedInstances = instances.filter(i => i.dates).sort((a,b) => new Date(a.dates.start).getTime() - new Date(b.dates.start).getTime())
  const upcoming: EventListPublishInstance[] = datedInstances.filter(i => new Date(i.dates.end).getTime() >= now)
  const past: EventListPublishInstance[] = datedInstances.filter(i => new Date(i.dates.end).getTime() < now).reverse()
  const noDateInstances = instances.filter(i => !i.dates).sort(sortByProp('eventName'))
  // console.log({ upcoming, past, noDateInstances })
  return { upcoming: [...noDateInstances, ...upcoming], past }
}